// extracted by mini-css-extract-plugin
export default {"sub_heading":"SubHeading_sub_heading__QAkUt"};